import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function TermsOfSale() {
  return (
    <PolicyPage title="Terms of Sale">
      <p>These terms apply to purchases from camartzuno and supplement our <Link to="/terms">Terms of Service</Link>. Mandatory consumer rights always remain available.</p>

      <h2>Product listings</h2>
      <p>We aim to show accurate descriptions, dimensions, materials, colors, and images. Colors vary by display, and natural or handmade materials may reasonably vary in grain, shade, texture, or finish. Accessories shown for styling are included only when the listing says so.</p>

      <h2>Prices and taxes</h2>
      <p>Prices and currency appear on the product page and at checkout. Shipping, taxes, duties, and other charges are shown or described before purchase where reasonably possible. We may correct an obvious pricing or description error before accepting an order and will offer cancellation and a refund if payment was already taken.</p>

      <h2>Placing and accepting an order</h2>
      <p>Your checkout submission is an offer to buy. An automated acknowledgment confirms receipt, not acceptance. A contract is formed when we send an acceptance or dispatch confirmation, or otherwise begin fulfilment. We may decline or limit an order for stock, payment, fraud, legal, shipping, or obvious error reasons.</p>

      <h2>Payment</h2>
      <p>You authorize the stated amount and confirm that you may use the selected payment method. Payment may be authorized at checkout and captured when accepted or shipped. If only part of an order can be fulfilled, we may charge only that part or refund the unavailable part.</p>

      <h2>Availability, limits, and substitutions</h2>
      <p>Products remain subject to availability. We do not substitute a materially different product without consent. Reasonable packaging changes that do not reduce the product's essential characteristics may occur.</p>

      <h2>Delivery, cancellation, and returns</h2>
      <p>Our <Link to="/shipping">Shipping &amp; Delivery Policy</Link>, <Link to="/order-policy">Order &amp; Cancellation Policy</Link>, and <Link to="/returns">Returns, Refunds &amp; Exchanges Policy</Link> form part of these terms.</p>

      <h2>Product use and safety</h2>
      <p>Use products only for their intended purpose and follow all labels, care instructions, temperature limits, age warnings, and food-safety guidance. Inspect goods before use. Stop using a product that is damaged or appears unsafe and contact us.</p>

      <h2>Warranties</h2>
      <p>Products are covered by any express warranty stated on the product page and by non-excludable statutory guarantees. Additional details appear in our <Link to="/warranty">Warranty Policy</Link>.</p>

      <h2>Business purchases</h2>
      <p>If you buy wholly for business use, consumer cancellation rights may not apply. Unless separately agreed in writing, products are not supplied for resale, safety-critical use, or commercial production.</p>

      <h2>Contact</h2>
      <p>Questions about an order may be sent to <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default TermsOfSale;
